import LegalLayout, { LegalSection } from "../components/LegalLayout";

export default function Datenschutz() {
  return (
    <LegalLayout eyebrow="Rechtliches" title="Datenschutzerklärung">
      <LegalSection title="1. Verantwortlicher">
        <p>
          Verantwortlich für die Datenverarbeitung auf dieser Website ist:
        </p>
        <p>
          Vintage Billard, Inhaber: Ahmed Murat
          <br />
          Hemelinger Heerstraße 7, 28309 Bremen
          <br />
          Telefon: 0176 32526128 · E-Mail: vintagebillard@gmail.com
        </p>
      </LegalSection>

      <LegalSection title="2. Zugriffsdaten und Hosting">
        <p>
          Beim Aufruf dieser Website werden durch den Hosting-Anbieter automatisch Informationen
          in sogenannten Server-Log-Dateien gespeichert (z. B. IP-Adresse, Datum und Uhrzeit des
          Zugriffs, Browsertyp). Diese Daten dienen der technischen Bereitstellung und Sicherheit
          der Website (Art. 6 Abs. 1 lit. f DSGVO) und werden nicht mit anderen Datenquellen
          zusammengeführt.
        </p>
      </LegalSection>

      <LegalSection title="3. Kontaktaufnahme">
        <p>
          Bei Kontaktaufnahme per E-Mail oder Telefon werden die übermittelten Daten (z. B. Name,
          E-Mail-Adresse, Telefonnummer) zur Bearbeitung der Anfrage verarbeitet (Art. 6 Abs. 1
          lit. b DSGVO). Die Daten werden gelöscht, sobald sie für den Zweck nicht mehr
          erforderlich sind und keine gesetzlichen Aufbewahrungspflichten bestehen.
        </p>
      </LegalSection>

      <LegalSection title="4. Google Maps">
        <p>
          Diese Website bindet Kartenmaterial von Google Maps ein (Anbieter: Google Ireland
          Limited, Gordon House, Barrow Street, Dublin 4, Irland). Beim Aufruf der Karte wird
          deine IP-Adresse an Google übertragen; dabei können Daten auch in die USA übermittelt
          werden. Die Nutzung erfolgt im Interesse einer ansprechenden Darstellung und leichten
          Auffindbarkeit unseres Standorts (Art. 6 Abs. 1 lit. f DSGVO). Details findest du in der
          Datenschutzerklärung von Google: policies.google.com/privacy.
        </p>
      </LegalSection>

      <LegalSection title="5. Schriftarten (Google Fonts)">
        <p>
          Zur einheitlichen Darstellung werden Schriftarten von Google Fonts geladen. Beim Aufruf
          der Seite baut dein Browser eine Verbindung zu Servern von Google auf, wobei deine
          IP-Adresse übermittelt wird (Art. 6 Abs. 1 lit. f DSGVO).
        </p>
      </LegalSection>

      <LegalSection title="6. Cookies und Tracking">
        <p>
          Diese Website verwendet keine Cookies zu Analyse- oder Marketingzwecken und keine
          Tracking-Tools.
        </p>
      </LegalSection>

      <LegalSection title="7. Deine Rechte">
        <p>
          Du hast das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der
          Verarbeitung deiner personenbezogenen Daten, das Recht auf Datenübertragbarkeit sowie
          das Recht, einer Verarbeitung zu widersprechen. Zudem besteht ein Beschwerderecht bei
          der zuständigen Aufsichtsbehörde: Die Bremische Beauftragte für Datenschutz und
          Informationsfreiheit, Arndtstraße 1, 27570 Bremerhaven.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
